import Vue from 'vue'
import platform from '@/platform'
import { ossOriginUrl, ossUrl } from './oss'
import * as business from './business'
import store from '@/store'
import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

// 环境数据
function envPrototype(Vue, options) {
  let isIos
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    // 判断iPhone|iPad|iPod|iOS
    isIos = true
  } else {
    isIos = false
  }

  Vue.prototype.$env = {
    // 是否为IOS
    isIos,
    // 平台回调函数
    deviceCallback(ios, android) {
      if (this.isIos) {
        ios && ios()
      } else {
        android && android()
      }
    },
    // 定制alert方法
    alert(name) {
      var iframe = document.createElement('IFRAME')
      iframe.style.display = 'none'
      iframe.setAttribute('src', 'about:blank;')
      document.documentElement.appendChild(iframe)
      window.frames[0].window.alert(name)
      iframe.parentNode.removeChild(iframe)
    },
    // 功能被禁止弹窗
    isIosAlert() {
      this.alert('由于相关规范，苹果设备暂不可使用此功能')
    },
    ossOriginUrl,
    ossUrl
  }
}
// 数据缓存
function dataCache(Vue, options) {
  Vue.prototype.$cache = {
    save: function(payload) {
      return store.commit('dataCache/SET_CACHEDATA', payload)
    },
    get: function(payload) {
      return store.getters['dataCache/getData'](payload)
    }
  }
}
// 业务函数
function addBusiness(params) {
  Vue.prototype.$business = business
}
Vue.prototype.$platform = platform
Vue.prototype.$commit = store.commit
Vue.prototype.$dispatch = store.dispatch
Vue.use(envPrototype)
Vue.use(dataCache)
Vue.use(addBusiness)
export default Vue
